// Function to calculate Levenshtein distance between two strings
function levenshteinDistance(s1: string, s2: string) {
  const len1 = s1.length
  const len2 = s2.length
  const dp = Array.from(Array(len1 + 1), () => Array(len2 + 1).fill(0))

  for (let i = 0; i <= len1; i++) dp[i][0] = i
  for (let j = 0; j <= len2; j++) dp[0][j] = j

  for (let i = 1; i <= len1; i++) {
    for (let j = 1; j <= len2; j++) {
      const cost = s1[i - 1] === s2[j - 1] ? 0 : 1
      dp[i][j] = Math.min(
        dp[i - 1][j] + 1, // deletion
        dp[i][j - 1] + 1, // insertion
        dp[i - 1][j - 1] + cost, // substitution
      )
    }
  }

  return dp[len1][len2]
}

/**
 * Checks the similarity of a string against a list of strings
 *
 * @param stringToCheck The string to check
 * @param checkList The list to check against
 * @returns An object with the best match and its similarity (if any)
 */
export function checkStringSimilarity(stringToCheck: string, checkList: Array<string>) {
  let bestMatch = ''
  let lowestDistance = Infinity

  checkList.forEach(targetString => {
    const distance = levenshteinDistance(stringToCheck, targetString)
    if (distance < lowestDistance) {
      lowestDistance = distance
      bestMatch = targetString
    }
  })

  const similarity = 1 - lowestDistance / Math.max(stringToCheck.length, bestMatch.length)

  return {
    bestMatch: similarity > 0 ? bestMatch : undefined,
    similarity: parseFloat(similarity.toFixed(1)),
  }
}
